import type { CollectionListResponse } from "#root/utility/remote-collection";
import type { RecordModificationResponse } from "#root/utility/remote-data";

type Row = Record<string, unknown> & { id: string | number };

export function mergeIntoResult<T extends Row>(
  { ...newResult }: CollectionListResponse<T>,
  modification: RecordModificationResponse<T>,
): CollectionListResponse<T> {
  const rows = newResult.rows;
  if ("created" in modification) {
    if (newResult.foundRows != null) newResult.foundRows++;

    newResult.rows = [...rows, modification.row];
  } else if ("updated" in modification) {
    const idx = rows.findIndex(element => element.id === modification.updated);
    if (idx === -1) {
      throw new Error("Couldn't find record to update in collection");
    }

    const newRows: T[] = [];
    for (let i = 0; i < rows.length; i++) {
      newRows.push(i === idx ? modification.row : rows[i]);
    }
    newResult.rows = newRows;
  } else if ("deleted" in modification) {
    const idx = rows.findIndex(element => element.id === modification.deleted);
    if (idx === -1) {
      throw new Error("Couldn't find record to update in collection");
    }

    const newRows: T[] = [];
    for (let i = 0; i < rows.length; i++) {
      if (i === idx) {
        if (modification.row) {
          newRows.push(modification.row);
        } else {
          if (newResult.foundRows != null) {
            newResult.foundRows--;
          }
        }
      } else {
        newRows.push(rows[i]);
      }
    }
    newResult.rows = newRows;
  } else {
    console.log("No merge action detected in response:", newResult);
    newResult.rows = rows;
  }
  return newResult;
}
